// extracted by mini-css-extract-plugin
module.exports = {"creation":"styles_creation__YC6Bp","containerTickets":"styles_containerTickets__3JHv-","ticket":"styles_ticket__37CQE"};